import React from 'react'
import { CopyIcon } from '../../Assest/icons/icons'

const ModuleAnalytics = () => {
  return (
    <div className="taskList analytics">
         <div className="copyInfos">
        <div className="copy-item">
          <p className="title">Request Code</p>
          <div className="wrapper">
            <p>
              djasdasd-vd--vs-dasd--d-43-432--324v-234-32vfdsfvsdf-ds-fds-fv-sdf-vf--324-32-4v-4-ef-svfvsdfsdfs-dvfsdfdsfsdfs
            </p>
            <button className="actionButton">
              <CopyIcon /> Copy
            </button>
          </div>
        </div>
        <div className="copy-item">
          <p className="title">Request Code</p>
          <div className="wrapper">
            <p>
              djasdasd-vd--vs-dasd--d-43-432--324v-234-32vfdsfvsdf-ds-fds-fv-sdf-vf--324-32-4v-4-ef-svfvsdfsdfs-dvfsdfdsfsdfs
            </p>
            <button className="actionButton">
              <CopyIcon /> Copy
            </button>
          </div>
        </div>
      </div> 
    </div>
  )
}

export default ModuleAnalytics